// components/CustomHelmet.js
import { Helmet } from "react-helmet";
import { isHaddockHostname } from "utils/haddockDomain";

const haddockInfo = {
	title: "haddock HR",
	description: "Planificación de turnos con IA para mejorar la rentabilidad",
	favicon: "/haddock/favicon.ico",
	appleTouchIcon: "/haddock/apple-touch-icon.png",
};

const localInfo = {
	title: "haddock",
	description: "Versión local de la app de haddock",
	favicon: "/haddock/favicon.ico",
	appleTouchIcon: "/haddock/apple-touch-icon.png",
};

const plainInfo = {
	title: "Plain App",
	description: "Planificación de turnos con IA",
	favicon: "/favicon.ico",
	appleTouchIcon: "/apple-touch-icon.png",
};

const CustomHelmet = () => {
	const hostname = window.location.hostname;
	const info = !isHaddockHostname(hostname)
		? plainInfo
		: hostname === "haddock.local"
			? localInfo
			: haddockInfo;
	return (
		<Helmet>
			<title>{info.title}</title>
			<meta name="apple-mobile-web-app-title" content={info.title} />
			<meta name="description" content={info.description} />
			<link rel="icon" href={info.favicon} />
			<link rel="apple-touch-icon" href={info.appleTouchIcon} />
		</Helmet>
	);
};

export default CustomHelmet;
